<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>会社詳細</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.admin.mst.company.error."/>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>グループ分類<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-select
            v-model="form.groupSmallId"
            :items="view.groupList"
            label="グループ分類を選択してください"
            item-text="text"
            item-value="value"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>会社名<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.companyName"
            hide-details
            placeholder="会社名を入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>会社名カナ</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.companyNameKana"
            hide-details
            placeholder="会社名カナを入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>表示順</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.displayOrder"
            hide-details
            placeholder="表示順を入力してください"
            solo
            dense
            maxlength="4"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          ※表示順はクラブの場合のみ設定してください。
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goModify">変更する</mp-button>
        <mp-dialog modify :show="dialog.modifyComplete" @clickOk="goList" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h1>会社削除</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          会社を削除する場合は、以下のボタンをクリックしてください。
          <br>※関連する支社・支局／媒体は同時に削除されます。
          <br>※関連するアカウント、アカウント申請が存在する場合は削除できません。
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <div>
          <mp-button red wide :disabled="!view.isDeletable" :disabledBtn="!view.isDeletable" @click.stop="dialog.deleteConfirm = true">削除する</mp-button>
        </div>
        <mp-dialog delete confirm :show="dialog.deleteConfirm" @clickOk="goDelete" @clickCancel="dialog.deleteConfirm = false"/>
        <mp-dialog delete :show="dialog.deleteComplete" @clickOk="goList" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h1>支社・支局／媒体一覧</h1>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="3" class="py-0">
        <mp-button min wide @click="goAddBranch">支社・支局／媒体追加</mp-button>
      </v-col>
    </v-row>

    <template v-if="view.branchList.length > 0">
      <v-row class="mt-5">
        <v-col cols="12" class="py-0">
          <div class="text-right ma-0 py-0 list-count">一覧件数：{{ view.branchList.length | addComma }}件</div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
            :headers="branchHeaders"
            :items="view.branchList"
            item-key="branchId"
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            fixed-header
            mobile-breakpoint=0
            hide-default-footer
            class="elevation-1"
            :items-per-page="-1"
          >
            <template v-slot:item="{ item }">
                <tr>
                  <td><router-link :to="`/admin/mst/branch/detail/${item.branchId}`">{{ item.branchName }}</router-link></td>
                  <td align="center">{{ item.accountCount | addComma }}</td>
                  <td align="center">{{ item.accountEntryCount | addComma }}</td>
                </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            支社・支局／媒体は、ありません。
          </div>
        </v-col>
      </v-row>
    </template>

  </v-container>
</template>

<script>
import { Common, AdminMstCompany } from '@/api'
import MpLabel from '@/components/item/MpLabel'
import MpInputBox from '@/components/item/MpInputBox'
import MpError from '@/components/item/MpError'
import MpButton from '@/components/item/MpButton'
import MpDialog from '@/components/item/MpDialog'

export default {
  name: 'AdminMstCompanyDetail',
  components: {
    MpLabel,
    MpInputBox,
    MpError,
    MpButton,
    MpDialog
  },
  data: () => ({
    view: {
      errors: [],
      groupList: [],
      branchList: [],
      isDeletable: false
    },
    form: {
      companyId: null,
      groupSmallId: null,
      companyName: '',
      companyNameKana: '',
      displayOrder: null
    },
    branchHeaders: [
      { text: '支社・支局／媒体名', value: 'branchName', sortable: false },
      { text: 'アカウント数', value: 'accountCount', align: 'center', sortable: false, width: 150 },
      { text: 'アカウント申請数', value: 'accountEntryCount', align: 'center', sortable: false, width: 150 }
    ],
    dialog: {
      modifyComplete: false,
      deleteConfirm: false,
      deleteComplete: false
    },
    errMessageReplaceList: []
  }),
  methods: {
    goList () {
      this.$router.push({ path: '/admin/mst/company/list' })
    },
    goAddBranch () {
      this.$router.push({ path: `/admin/mst/company/${this.form.companyId}/branch/add` })
    },
    async goModify () {
      this.errMessageReplaceList = []
      await AdminMstCompany.update(this.form)
        .then(() => { this.dialog.modifyComplete = true })
        .catch(error => {
          this.view.errors = error.messages
          this.errMessageReplaceList = error.messages
            .filter(message => message.unavailableServices)
            .map(message => {
              return {
                param: message.param,
                pattern: '##UNAVAILABLE_SERVICE_NAMES##',
                replacement: { ja: message.unavailableServices.map(unavailableService => { return unavailableService.serviceNameJp }).join(',') }
              }
            })
        })
    },
    async goDelete () {
      await AdminMstCompany.delete({ companyId: this.form.companyId })
        .then(() => { this.dialog.deleteComplete = true })
        .catch(error => {
          this.dialog.deleteConfirm = false
          this.view.errors = error.messages
        })
    }
  },
  created: async function () {
    const companyId = this.$route.params.id

    this.view.groupList = (await Common.groupList())
      .filter(groupLarge => groupLarge.companyInsNoFlg === '0')
      .flatMap(groupLarge => groupLarge.groupSmallList
        .map(groupSmall => ({
          text: groupLarge.groupLargeName.ja + '＞' + groupSmall.groupSmallName.ja,
          value: groupSmall.groupSmallId
        })))

    const result = await AdminMstCompany.detail({ companyId: companyId })
      .catch(error => {
        this.view.errors = error.messages
      })

    this.view.branchList = result.branchList
    this.view.isDeletable = result.isDeletable

    this.form = {
      companyId: companyId,
      groupSmallId: result.groupSmallId,
      companyName: result.companyName,
      companyNameKana: result.companyNameKana,
      displayOrder: result.displayOrder
    }
  }
}
</script>
